import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import crudApi from "@serie3/common/api/crudApi";
import listHandler from "@serie3/common/Domain/listHandler";

const CommentView = ({
  index,
  keyValueObject,
  setShowEdit,
  setEditFunction,
  setKeyValueData,
  keyValueDataList,
  showErrorFunction,
  deleteUrl,
}) => {
  const deleteData = async () => {
    listHandler.deleteFromList(
      index,
      crudApi.del(deleteUrl, keyValueObject.id),
      setKeyValueData,
      keyValueDataList,
      showErrorFunction
    );
  };

  const initials = keyValueObject.key_name
    ? keyValueObject.key_name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()
    : "?";

  return (
    <div style={{
      display: "flex", gap: "12px", padding: "14px 0",
      borderBottom: "1px solid #f0f0f0",
    }}>
      {/* Avatar */}
      <div style={{
        width: "36px", height: "36px", borderRadius: "50%",
        background: "linear-gradient(135deg, #1a73e8, #0d47a1)",
        color: "#fff", display: "flex", alignItems: "center",
        justifyContent: "center", fontWeight: 700, fontSize: "0.72rem",
        flexShrink: 0,
      }}>
        {initials}
      </div>

      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "4px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontWeight: 700, fontSize: "0.88rem", color: "#212121" }}>
              {keyValueObject.key_name}
            </span>
            <span style={{ fontSize: "0.75rem", color: "#9e9e9e" }}>
              {keyValueObject.date}
            </span>
          </div>
          <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
            <button
              type="button"
              onClick={() => { setEditFunction(keyValueObject); setShowEdit(true); }}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: "#9e9e9e", padding: "4px 6px", borderRadius: "6px",
                fontSize: "0.75rem", transition: "color 0.15s, background 0.15s",
              }}
              onMouseOver={e => { e.currentTarget.style.color = "#1a73e8"; e.currentTarget.style.background = "#e8f0fe"; }}
              onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
            >
              <FontAwesomeIcon icon={faPen} />
            </button>
            <button
              type="button"
              onClick={deleteData}
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: "#9e9e9e", padding: "4px 6px", borderRadius: "6px",
                fontSize: "0.75rem", transition: "color 0.15s, background 0.15s",
              }}
              onMouseOver={e => { e.currentTarget.style.color = "#c62828"; e.currentTarget.style.background = "#ffebee"; }}
              onMouseOut={e => { e.currentTarget.style.color = "#9e9e9e"; e.currentTarget.style.background = "none"; }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>
        <p style={{ margin: 0, fontSize: "0.88rem", color: "#424242", lineHeight: 1.5 }}>
          {keyValueObject.value}
        </p>
      </div>
    </div>
  );
};

export default CommentView;
